import _extends from "@swc/helpers/src/_extends.mjs";
import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import Svg from "../Svg";
var Icon = function(_param) /*#__PURE__*/ {
    var props = _extends({}, _param);
    return _jsx(Svg, _object_spread_props(_object_spread({
        width: "25",
        height: "24",
        viewBox: "0 0 25 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ _jsx("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.34316 15.7426C6.95264 16.1331 6.95264 16.7663 7.34316 17.1568C7.73368 17.5473 8.36685 17.5473 8.75737 17.1568L16.9498 8.96443L16.9498 15.0355C16.9498 15.5878 17.3975 16.0355 17.9498 16.0355C18.502 16.0355 18.9498 15.5878 18.9498 15.0355L18.9498 6.55022C18.9498 6.285 18.8444 6.03065 18.6569 5.84311C18.4693 5.65557 18.215 5.55022 17.9498 5.55022L9.46448 5.55022C8.9122 5.55022 8.46448 5.99793 8.46448 6.55022C8.46448 7.1025 8.9122 7.55022 9.46448 7.55022L15.5355 7.55022L7.34316 15.7426Z",
            fill: "#03F5AE"
        })
    }));
};
export default Icon;
